import React, { FC } from 'react'
import GenericModal from '../../../widgets/GenericModal'
import { APP_NAME } from '../../../constants'

interface Props {
  isOpen: boolean
  onCancel: () => void
  onSubmit: () => void
}

const SearchResultsLimitModal: FC<Props> = (props) => {
  const { isOpen, onCancel, onSubmit } = props

  return (
    <GenericModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSubmit={onSubmit}
      headingText={`Get more organized with ${APP_NAME} Pro`}
      bodyText={`Searching for something from more than 30 days ago? Upgrade to ${APP_NAME} Pro for all-time search!`}
      cancelButtonText="Dismiss"
      submitButtonText="Upgrade"
    />
  )
}

export default SearchResultsLimitModal
